// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../node_modules/css-loader/dist/cjs.js??clonedRuleSet-4.use[1]!../../node_modules/vue-loader/dist/stylePostLoader.js!../../node_modules/postcss-loader/src/index.js??clonedRuleSet-4.use[2]!../../node_modules/sass-loader/dist/cjs.js??clonedRuleSet-4.use[3]!../../node_modules/vue-loader/dist/index.js??ruleSet[1].rules[7].use[0]!./GetStartedQuiz.vue?vue&type=style&index=0&id=afa68218&lang=scss&scoped=true");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../../node_modules/vue-style-loader/lib/addStylesClient.js").default
var update = add("717d9239", content, true, {});